
































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import { checkMobile } from '../../utils/utils'
import ExamButton from '../organisms/ExamButton.vue'
import { format } from 'date-fns'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import Exam from '../../models/exam'
import api from '../../../api/v2/api'
import { snackBarState } from '../../stores/snackbar'
const RobotImg = require("../../../../images/robot.png")

@Component({
  components: {
    ExamButton
  }
})
export default class ExamDetail extends Vue {
  ROUTER_NAME = ROUTER_NAME
  RobotImg = RobotImg
  isMobile: boolean = false
  skills = []
  headers = [
    {
      text: 'Skill',
      value: 'skill',
      sortable: false
    },
    {
      text: 'Skill Items',
      value: 'skillItems',
      sortable: false
    }
  ]

  get breadcrumbs(){
    if (this.$route.params.userGoalId) {
      return [
        {
          text: 'ゴール一覧',
          disabled: false,
          exact: true,
          to: `/classroom/user-goals`
        },
        {
          text: 'ゴール詳細',
          disabled: false,
          exact: true,
          to: `/classroom/user-goals/${this.$route.params.userGoalId}`
        },
        {
          text: this.exam ? this.exam.name : '',
          disabled: true,
          exact: true,
        }
      ]
    }

    return [
      {
        text: 'テスト一覧',
        disabled: false,
        exact: true,
        to: '/classroom/exam-list'
      },
      {
        text: this.exam ? this.exam.name : '',
        disabled: true,
        exact: true,
      }
    ]
  }

  get user(){
    return userState.user
  }

  exam: Exam | null = null

  async created() {
    this.isMobile = checkMobile()
    this.exam = await snackBarState.runWithLoading(
      api.exam.showForSummary(parseInt(this.$route.params.examId), {})
    )
    
    headerState.setTitle(this.exam.name)
    this.skills = this.exam.examSkills.map(examSkill => {
      return {
        skill: examSkill.name,
        skillItems: examSkill.skillItems.map(item => item.name)
      }
    })
  }

  dateFormat(date: string) {
    return format(date, 'YYYY/MM/DD')
  }
}
